var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2584_17389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.12 6.11993C21.0371 6.00163 20.9177 5.9138 20.78 5.86993L12.25 2.79993C12.1473 2.78381 12.0427 2.78381 11.94 2.79993H11.79L3.22001 5.86993C3.08396 5.91687 2.96539 6.00406 2.88001 6.11993C2.79285 6.23481 2.74705 6.37576 2.75001 6.51993V17.5199C2.75334 17.66 2.79862 17.7959 2.88001 17.9099C2.96881 18.02 3.08656 18.1031 3.22001 18.1499L11.75 21.2299C11.9124 21.2833 12.0876 21.2833 12.25 21.2299L20.78 18.1499C20.912 18.1056 21.0272 18.0218 21.11 17.9099C21.2001 17.796 21.2493 17.6552 21.25 17.5099V6.50993C21.248 6.36963 21.2025 6.2334 21.12 6.11993V6.11993ZM11.28 10.0599V19.5599L4.20001 16.9999V7.50993L11.28 10.0599ZM18.49 6.50993L12 8.84993L5.51001 6.50993L12 4.16993L18.49 6.50993ZM19.8 7.50993V16.9999L12.72 19.5599V10.0599L19.8 7.50993Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2584_17389"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.5,
    height: 18.5,
    fill: "currentColor",
    transform: "translate(2.75 2.75)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.857a6365baeb8ee6387c185f5c1308e0.svg";
export { ForwardRef as ReactComponent };